import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconPinProps extends SVGProps<any> {}
export class SVGIconPin extends Component<SVGIconPinProps> {
  render() {
    const { width = 256, height = 256, fill, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-arrow-up"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 256 256`}
        fill={fill}
        {...rest}
      >
        <g>
          <path
            fill={fill}
            stroke={fill}
            d="M244.2,81L175,11.8c-1.3-1.3-3.2-2-5.1-1.7c-1.9,0.2-3.5,1.3-4.5,3c-5.9,10.4-7,23.5-3.1,36.7L116,95.9c-12-6-24.6-9.2-36.9-9.2c-16.4,0-31.3,5.8-41.8,16.4c-1.1,1.1-1.8,2.7-1.8,4.3c0,1.6,0.7,3.2,1.8,4.3l43.8,43.8L11.5,236c-2.1,2.4-2,6,0.3,8.3c1.2,1.2,2.7,1.8,4.3,1.8c1.4,0,2.8-0.5,3.9-1.5l80.5-69.6l43.8,43.8c2.4,2.4,6.2,2.4,8.6,0c19-18.9,21.6-50.1,7.2-78.8l46.3-46.3c13,3.9,26.4,2.8,36.7-3.1c1.6-0.9,2.7-2.6,3-4.5C246.2,84.2,245.6,82.3,244.2,81z"
          />
        </g>
      </SVG>
    );
  }
}
